import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  delivery: [],
  storeDeliveryDetail: {},
  deliveryList: [],
};

const deliverySlice = createSlice({
  name: 'rounds',
  initialState,
  reducers: {
    loadDeliveryDetailsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadDeliveryDetailsSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.deliveryCharges = action.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadDeliveryDetailsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadDeliveryChargesListRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadDeliveryChargesListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.deliveryChargesList = action.payload?.result;
    },
    loadDeliveryChargesListFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeDeliveryDetailRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeDeliveryDetailSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeDeliveryDetail = action.payload;
    },
    storeDeliveryDetailFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateDeliveryDetailRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateDeliveryDetailSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateDeliveryDetail = action.payload;
    },
    updateDeliveryDetailFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    archiveDeliveryDetailRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    archiveDeliveryDetailSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.archivePaper = action.payload;
    },
    archiveDeliveryDetailFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadAssignDeliveryDetailRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadAssignDeliveryDetailSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.rounds = action?.payload?.results;
    },
    loadAssignDeliveryDetailFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadDeliveryDetailsRequested,
  loadDeliveryDetailsSuccess,
  loadDeliveryDetailsFail,
  loadDeliveryChargesListRequested,
  loadDeliveryChargesListSuccess,
  loadDeliveryChargesListFail,
  loadAssignDeliveryDetailRequested,
  loadAssignDeliveryDetailSuccess,
  loadAssignDeliveryDetailFail,
  storeDeliveryDetailRequested,
  storeDeliveryDetailSuccess,
  storeDeliveryDetailFail,
  updateDeliveryDetailRequested,
  updateDeliveryDetailSuccess,
  updateDeliveryDetailFail,
  archiveDeliveryDetailRequested,
  archiveDeliveryDetailSuccess,
  archiveDeliveryDetailFail,
} = deliverySlice.actions;

export default deliverySlice.reducer;
